// extracted by mini-css-extract-plugin
export default {"container":"purchases_container__D5J7J","spin":"purchases_spin__3RO6m","title":"purchases_title__Os7yo","header":"purchases_header__mvADX","content":"purchases_content__4aHzL"};